import type { ColTypeDef } from 'ag-grid-community';

import { BooleanCellRenderer } from '../CellRenderers';
const serverSideColumnType = {
  cellRenderer: BooleanCellRenderer,
  minWidth: 50,
};
export const booleanColumnType: ColTypeDef = {
  ...serverSideColumnType,
  filter: 'agSetColumnFilter',
  filterParams: {
    suppressMiniFilter: true,
    values: [true, false],
  },
};

export function useBooleanColumnType<T>() {
  return booleanColumnType as ColTypeDef<T>;
}

export function useServerSideBooleanColumnType<T>() {
  return serverSideColumnType as ColTypeDef<T>;
}
